import { Controller, useFormContext, Control } from 'react-hook-form';
import { CustomPhoneInput } from './Custom/CustomPhoneInput/CustomPhoneInput';
import { ICustomSelect } from './Custom/CustomSelect';

interface IFormSelect extends ICustomSelect {
  control?: Control<any>;
  name: string;
  [x: string]: any;
}

export const FormPhoneInput = (props: IFormSelect) => {
  const { control, ...restProps } = props;
  const methods = useFormContext();
  const _control = methods?.control || control;

  return _control ? (
    <Controller
      control={_control}
      name={restProps?.name}
      render={(renderProps) => {
        const {
          field,
          fieldState: { error },
        } = renderProps;
        const { ref, ...restFieldProps } = field;

        return <CustomPhoneInput {...restProps} {...restFieldProps} error={error} />;
      }}
    />
  ) : (
    <CustomPhoneInput {...restProps} />
  );
};
